export default __webpack_public_path__ + "static/media/Red 01.0be9bc89.svg";